const {_} = require('../globals');
(function Module() {
	'use strict';

	mySynch.factory('FertilityFactory', [
		'$window',
		'MySynchFactory',
		'ApiFactory',
		'clientLoggerService',
		function FertilityFactory($window, MSF, api, log) {
			function getDaysPastAI() {
				return	MSF.getActiveHerdFertilityProgram().timeUnitTypeId === _.get(_.find(MSF.lists.unitType,{code:"WEEK"}),'unitTypeId') ?
						MSF.getActiveHerdFertilityProgram().timeAfterAIPregCheck * 7 : MSF.getActiveHerdFertilityProgram().timeAfterAIPregCheck;
			}

			function getRecheckDaysPastAI() {
				return MSF.getActiveHerdFertilityProgram().recheckDaysAfterAI;
			}

			var numberOfProtocols = 3;
			var defaultProtocols = _.map(_.range(0, numberOfProtocols), function returnProtocol(id) {
				return {protocolTypeId: id + 1};
			});

			//	get these from db
			var originalProtocols = [];
			var activeHerdFertilityPlan = null;
			var originalActiveHerdFertilityPlan = null;

			var ffExports = {
				load: {
					herdFromDb: function loadHerdFromDb(performanceContext, callback) {
						api.getHerd(MSF.getActiveHerd().herdId, performanceContext, function herdGotten(err, herd) {
							if (err) {
								log.error('Error getting herd: ' + err);
							}

							MSF.setActiveHerd(herd, true);

							if (_.isFunction(callback)) {
								callback();
							}
						});
					},

					planAndProtocols: function loadPlanAndProtocols(parityTypeId, performanceContext, callback) {
						var protocols = ffExports.protocol.inputs = _.cloneDeep(defaultProtocols);

						originalActiveHerdFertilityPlan = originalActiveHerdFertilityPlan || _.cloneDeep(activeHerdFertilityPlan);
						originalProtocols = [];

						var apiFunctions = {
							getHerdFertilityPlan: function getHerdFertilityPlan(done) {
								api.getHerdFertilityPlansByHerdFertilityProgramIdAndParityTypeId({
									herdFertilityProgramId: MSF.getActiveHerdFertilityProgram().herdFertilityProgramId,
									parityTypeId: parityTypeId
								},
								performanceContext
								, function plansGotten(err, herdFertilityPlans) {
									if (err) {
										log.error('Error getting plans ' + err);
									}

									function updatePGCleanUpShot() {
										ffExports.pgCleanUpShot.inputs.timeToPGCleanShot	= activeHerdFertilityPlan.timeToPGCleanShot;
										ffExports.pgCleanUpShot.inputs.timeUnitTypeId		= activeHerdFertilityPlan.timeUnitTypeId;
									}

									activeHerdFertilityPlan = _.find(herdFertilityPlans, 'isActivePlan');

									if (activeHerdFertilityPlan) {
										updatePGCleanUpShot();
										done(null, activeHerdFertilityPlan);
									} else {
										log.info('No active herdFertilityPlans, creating a new one now');

										api.createHerdFertilityPlan({
											herdId: _.get(MSF.getActiveHerd(), 'herdId'),
											herdFertilityProgramId:		_.get(MSF.getActiveHerdFertilityProgram(),"herdFertilityProgramId"),	//MSF.getActiveHerdFertilityProgram().herdFertilityProgramId,
											parityTypeId:	parityTypeId,
											isActivePlan:	1,
											createdBy:		'mySynch'
										}, function herdFertilityPlanCreated(err, newHerdFertilityPlan) {
											if (err) {
												log.error('Error creating herdFertilityPlan ' + err);

												done(err);
											}

											log.info('Created new herdFertilityPlan with herdFertilityPlanId: ' + newHerdFertilityPlan.herdFertilityPlanId);
											activeHerdFertilityPlan = newHerdFertilityPlan;
											updatePGCleanUpShot();

											done(null, newHerdFertilityPlan);
										});
									}
								});
							}
						};

						_.forEach(_.range(0, numberOfProtocols), function eachProtocol(protocolId) {
							apiFunctions['getHerdFertilityProtocol' + (protocolId + 1)] = ['getHerdFertilityPlan', function getHerdFertilityProtocol(done, results) {
								api.getHerdFertilityProtocolByHerdFertilityPlanIdAndProtocolTypeId({
									herdFertilityPlanId: results.getHerdFertilityPlan.herdFertilityPlanId,
									protocolTypeId: protocolId + 1
								}, function protocolGotten(err, herdFertilityProtocol) {
									if (err) {
										log.error('Error getting protocol ' + (protocolId + 1));

										done(err);
									}

									if (herdFertilityProtocol) {
										herdFertilityProtocol.herdFertilityPlanId = (originalActiveHerdFertilityPlan || activeHerdFertilityPlan || {}).herdFertilityPlanId;

										_.assign(protocols[protocolId], {
											fertilityProgramTypeId:		herdFertilityProtocol.fertilityProgramTypeId,
											startWeekdayId:				herdFertilityProtocol.startWeekdayId,
											startWeek:					herdFertilityProtocol.startWeek,
											duration:					herdFertilityProtocol.duration || null,
											herdFertilityProtocolId:	herdFertilityProtocol.herdFertilityProtocolId
										});

										originalProtocols.push(herdFertilityProtocol);
									}

									done(null, herdFertilityProtocol);
								});
							}];
						});

						async.auto(apiFunctions, function allDone(err, finalResult) {
							if (err) {
								log.error({error: err}, 'Error getting protocols');

								if (_.isFunction(callback)) {
									callback(err);	//	TODO: Fix callbacks to expect an error
								}

								return false;
							}

							log.info('all done loading herd');
							ffExports.doneLoading = true;

							if (_.isFunction(callback)) {
								callback(finalResult);	//	TODO: Fix callbacks to expect an error:  i.e.  callback(null, finalResult);
							}
						});
					},

					autofillProtocols: function autofillProtocols(autofillParityTypeId) {	//	autofill protocols from previous parityType
						log.info('autofilling protocols with data from ParityType: ' + autofillParityTypeId);
						var unchangedOriginalProtocols = _.cloneDeep(originalProtocols);	//	get these ids before they're changed
						ffExports.load.planAndProtocols(autofillParityTypeId, function changeOriginalProtocolIdsBackToWhatTheyWereBefore() {
							log.info('done autofilling protocols with data from ParityType: ' + autofillParityTypeId);

							if (unchangedOriginalProtocols.length) {
								originalProtocols = _.map(originalProtocols, function mapEachOriginalProtocol(origProtocol) {
									var unchangedVersionOfThisProtocol = _.find(unchangedOriginalProtocols, {protocolTypeId: origProtocol.protocolTypeId});

									return _.extend({}, origProtocol, _.pick(unchangedVersionOfThisProtocol, [
										'herdFertilityPlanId',
										'herdFertilityProtocolId'
									]));
								});

								// if 3rd protocol is not selected in lactation 1 and the 3rd protocol exists in lactation 2+, retain it in protocols so it can be deleted
								if (_.isUndefined(_.find(originalProtocols, {protocolTypeId: 3})) && _.find(unchangedOriginalProtocols, {protocolTypeId: 3})) {
									var deletedProtocol = _.find(unchangedOriginalProtocols, {protocolTypeId: 3});
									deletedProtocol.fertilityProgramTypeId = null;

									originalProtocols.push(deletedProtocol);
								}
							} else {
								originalProtocols = [];	//	originalProtocols changes back to empty
							}
						});
					}
				},

				calendar: {
					getMaxWeeks: function getMaxWeeks() {
						var maxWeeks	= 24;
						var inputs		= ffExports && ffExports.protocol && ffExports.protocol.inputs;
						var selectedProtocols = _.filter(inputs, function onlyWithFertilityProgramTypeId(input) {
							return _.isNumber(input.fertilityProgramTypeId);
						});

						if (selectedProtocols.length) {
							var hoursPerDay		= 24;
							var daysPerWeek		= 7;
							var protocolSizes	= _.map(selectedProtocols, function eachInput(protocolInput, index) {
								var programDefinition = _.find(MSF.lists.fertilityProgramType, {fertilityProgramTypeId: protocolInput.fertilityProgramTypeId});

								if (programDefinition.code === 'HD') {
									programDefinition.duration = 0;
								}

								return _.ceil(programDefinition.duration / hoursPerDay) +
									(protocolInput.duration || 0) +
									(programDefinition.isTAI ? Math.max(getDaysPastAI(), getRecheckDaysPastAI()) : 0) +
									((protocolInput.startWeek || 1) * daysPerWeek);
							});

							maxWeeks = _.ceil((_.max(protocolSizes) + 1) / daysPerWeek);
						}

						return Math.min(52, maxWeeks);
					},

					cellInfo: function calendarCellInfo(week, day, parityTypeId) {
						function calculatePregCheckDay(dayIdPrecedingPregCheck) {
							function alternateCalculation() {
								return preferredPregCheckDayId - firstPossiblePregCheckDayId;
							}

							function defaultCalculation() {
								return (7 - firstPossiblePregCheckDayId) + preferredPregCheckDayId;
							}

							var firstPossiblePregCheckDayId = dayIdPrecedingPregCheck % 7;
							var preferredPregCheckDayId = herdFertilityProgram.preferredPregCheckDayId - 1;

							if (preferredPregCheckDayId >= firstPossiblePregCheckDayId) {
								return dayIdPrecedingPregCheck + alternateCalculation() + 1;
							}

							return dayIdPrecedingPregCheck + defaultCalculation() + 1;
						}

						var protocols = ffExports.protocol.inputs;
						var cellInfo = [];
						var herdFertilityProgram = MSF.getActiveHerdFertilityProgram();

						if (!herdFertilityProgram) {
							return cellInfo;
						}

						var daysPerWeek = MSF.lists.weekdayType.length;
						var hoursPerDay = 24;
						var dayNumber	= (week * daysPerWeek) + day.weekdayTypeId;
						var begOfNextProtocol = 0;
						var endOfLastProtocol = 0;

						var activitySubTypeValues = {
							BULLPEN:	{style: 'bp',	text: 'BULL'},
							INSEMINATE: {style: 'tai',	text: 'TAI'},
							PREGNANCY:	{style: 'pd',	text: 'PD'},
							SYNCCIDRIN: {style: 'cidr', text: 'CIDR'},
							SYNCGNRH:	{style: 'gnrh', text: 'GnRH'},
							SYNCPROST:	{style: 'pgf',	text: 'PGF'}
						};

						if (ffExports.pgCleanUpShot.show(parityTypeId)) {
							var delay = ffExports.pgCleanUpShot.inputs.timeToPGCleanShot;

							if (ffExports.pgCleanUpShot.inputs.timeUnitTypeId === _.get(_.find(MSF.lists.unitType,{code:"WEEK"}),'unitTypeId')) {
								delay *= 7;
							}

							if (dayNumber === delay) {
								cellInfo.push({
									style: 'pgf',
									text: 'PGF',
									amPm: null
								});
							}
						}

						if (parityTypeId > 1 && dayNumber === herdFertilityProgram['lactation' + (parityTypeId - 1) + 'VoluntaryWithholdPeriod']) {
							cellInfo.push({
								style: 'vwp',
								text: 'VWP',
								amPm: null
							});
						}

						_.forEach(protocols, function eachProtocol(protocol, protocolIndex) {
							var startProtocol		= (protocol.startWeek - 1) * daysPerWeek + protocol.startWeekdayId;
							var programDefinition	= _.find(MSF.lists.fertilityProgramType, {fertilityProgramTypeId: protocol.fertilityProgramTypeId});
							var protocolSequences	= _.where(MSF.lists.reproductiveProtocolSequence, {fertilityProgramTypeId: protocol.fertilityProgramTypeId});

							if (programDefinition) {
								// Determine when the protocol starts if not protocol 1
								if (protocolIndex) {
									// get the previous protocol to find out if it is heat detection
									var previousProtocolProgramDefinition = _.find(MSF.lists.fertilityProgramType, {fertilityProgramTypeId: protocols[protocolIndex - 1].fertilityProgramTypeId});
									// if current or previous program is heat detection, use the last day of previous protocol as start day for this protocol
									if (programDefinition.isHDAI || (previousProtocolProgramDefinition && previousProtocolProgramDefinition.isHDAI)) {
										// startProtocol = endOfLastProtocol;
										startProtocol = _.isNumber(_.get(protocol, 'startWeek')) ? (_.get(protocol, 'startWeek')) * daysPerWeek + protocol.startWeekdayId - daysPerWeek : endOfLastProtocol;
									} else {
										if (herdFertilityProgram.reSynchBeforeOrAfter === 'B') {
											startProtocol = endOfLastProtocol - daysPerWeek;
										} else if (herdFertilityProgram.reSynchBeforeOrAfter === 'A') {
											startProtocol = _.isNumber(_.get(protocol, 'startWeek')) ? (_.get(protocol, 'startWeek')) * daysPerWeek + protocol.startWeekdayId - daysPerWeek : endOfLastProtocol;
										}
									}
								}

								// add an event to a cell
								_.forEach(protocolSequences, function eachProtocolSequence(protocolSequence) {
									var fertilityProgramDefinedSequence = _.find(MSF.lists.fertilityProgramDefinedSequence, {
										fertilityProgramDefinedSequenceId: protocolSequence.fertilityProgramDefinedSequenceId
									});
									var activitySubType = _.find(MSF.lists.activitySubType, {
										activitySubTypeId: fertilityProgramDefinedSequence.activitySubTypeId
									});
									var protocolDays	= _.floor(protocolSequence.startHours / hoursPerDay);
									var inconsistentTai = activitySubType.code === 'INSEMINATE' && !programDefinition.commencementTAIHours;	//	logical inconsistency -- don't add TAI

									if (protocolDays + startProtocol === dayNumber && !inconsistentTai) {
										var activitySubTypeValue = activitySubTypeValues[activitySubType.code];

										cellInfo.push({
											style:	activitySubTypeValue.style,
											text:	activitySubTypeValue.text,
											amPm:	fertilityProgramDefinedSequence.amPmTypeId
										});
									}

									// CIDR duration
									if (fertilityProgramDefinedSequence.name === 'CIDR') {
										var cidrEnd =  _.floor(protocolSequence.stopHours / hoursPerDay);

										if ((protocolDays + startProtocol < dayNumber) && (protocolDays + startProtocol + cidrEnd > dayNumber)) {
											cellInfo.push({
												style: activitySubTypeValues.SYNCCIDRIN.style,
												amPm: null
											});
										}
									}
								});

								// Heat Detection
								if (programDefinition.isHDAI &&	protocol.duration) {
									var startHeatDetection = startProtocol;

									// TODO: This needs to change when nick adds the question for after which shot does HD follow
									if (programDefinition.injectionCountPGF > 1) {	//	2nd shot of 2 PG shot followed by HD (only)
										startHeatDetection += Math.floor(protocolSequences[1].startHours / hoursPerDay);
									}

									if (dayNumber >= startHeatDetection && dayNumber < startHeatDetection + protocol.duration) {
										cellInfo.push({style: 'hd'});
									}

									endOfLastProtocol = startHeatDetection + protocol.duration;
								}

								// Pregnancy Detection
								if (programDefinition.isTAI) {
									var taiId					= _.find(MSF.lists.activitySubType, {code: 'INSEMINATE'}).activitySubTypeId;
									var taiDefinedSequences		= _.where(MSF.lists.fertilityProgramDefinedSequence, {activitySubTypeId: taiId});
									var taiDefinedSequenceIds	= _.map(taiDefinedSequences, 'fertilityProgramDefinedSequenceId');
									var taiShot					= _.find(protocolSequences, function findTai(protocolSequence) {
										return _.includes(taiDefinedSequenceIds, protocolSequence.fertilityProgramDefinedSequenceId);
									});

									if (taiShot) {
										var taiShotDay		= startProtocol + _.floor(taiShot.startHours / hoursPerDay);
										var pregCheckDay	= calculatePregCheckDay(taiShotDay + getDaysPastAI());
										var recheckDay		= calculatePregCheckDay(taiShotDay + getRecheckDaysPastAI());
										endOfLastProtocol	= Math.max(pregCheckDay, recheckDay);

										// heat detect between TAI shot and the beginning of the next protocol
										if (herdFertilityProgram.heatDetectionFollowUpAfterTAI &&
										dayNumber > taiShotDay &&
										dayNumber < pregCheckDay) {
											var dayOfDeepHeatStart	= 18;
											var dayOfDeepHeatEnd	= 25;

											if (dayNumber > taiShotDay + dayOfDeepHeatStart &&
											dayNumber < taiShotDay + dayOfDeepHeatEnd) {
												cellInfo.push({style: 'hd-deep'});
											} else {
												cellInfo.push({style: 'hd'});
											}
										}

										if (pregCheckDay === dayNumber) {
											var activitySubTypeValue = activitySubTypeValues.PREGNANCY;

											cellInfo.push({
												style:	activitySubTypeValue.style,
												text:	activitySubTypeValue.text,
												amPm: null
											});
										}

										if (recheckDay === dayNumber) {
											cellInfo.push({
												style:	activitySubTypeValues.PREGNANCY.style,
												text:	activitySubTypeValues.PREGNANCY.text,
												amPm: null
											});
										}
									}
								}
							}
						});

						return cellInfo;
					},

					cellInfoWithoutHd: function cellInfoWithoutHd(week, day, parityTypeId) {
						return _.reject(_.reject(ffExports.calendar.cellInfo(week, day, parityTypeId), {style: 'hd'}), {style: 'hd-deep'});
					},

					cellInfoIsAllHd: function cellInfoIsAllHd(week, day, parityTypeId) {
						return _.every(ffExports.calendar.cellInfo(week, day, parityTypeId), function allStylesAreHd(cellInfoItem) {
							return _.includes(cellInfoItem.style, 'hd');
						});
					},

					legendProcedures: [
						{style: 'bp',			text: 'BULL',	description: 'Bull'},
						{style: 'tai',			text: 'TAI',	description: 'Timed Artificial Insemination'},
						{style: 'pd',			text: 'PD',		description: 'Pregnancy Detection'},
						{style: 'cidr',			text: 'CIDR',	description: 'Controlled Internal Drug Release'},
						{style: 'gnrh',			text: 'GnRH',	description: 'Gonadotropin'},
						{style: 'pgf',			text: 'PGF',	description: 'Prostaglandin'},
						{style: 'hd',			text: '',		description: 'Estrous Detection of Heat'},
						{style: 'hd-striped',	text: 'PGF',	description: 'Prostaglandin (2+ parity)'},
						{style: 'hd-deep',		text: '',		description: 'Expected Heat'},
						{style: 'vwp',			text: 'VWP',	description: 'Voluntary Waiting Period'}
					]	
				},

				protocol: {
					inputs: _.cloneDeep(defaultProtocols),

					questions: {
						startWeek:		'What week do you want to start the protocol?',
						startWeekdayId:	'What day do you want to start the protocol?',
						duration:		'When does this protocol end?'
					},

					range: {
						startWeek: {
							min: 1,
							max: 20
						},

						duration: {
							min: 0,
							max: 120
						}
					},

					sanitize: function sanitizeProtocols() {
						var protocols = ffExports.protocol.inputs;

						if (_.isUndefined(protocols[0].fertilityProgramTypeId) || _.isUndefined(protocols[1].fertilityProgramTypeId)) {
							protocols[1].fertilityProgramTypeId = undefined;
							protocols[2].fertilityProgramTypeId = undefined;
						}
					},

					save: function saveProtocols(parityTypeId, message, form) {
						var parallelFunctions = [];
						var protocols = ffExports.protocol.inputs;
						var lactation1Protocol3 = _.isUndefined(_.find(protocols, {protocolTypeId: 3}).fertilityProgramTypeId);

						if (lactation1Protocol3 && _.find(originalProtocols, {protocolTypeId: 3})) {
							var deletedProtocol = _.find(originalProtocols, {protocolTypeId: 3});
							deletedProtocol.fertilityProgramTypeId = null;

							protocols.push(deletedProtocol);
						}

						_.forEach(protocols, function eachProtocol(protocol) {
							// the third protocol is no longer required so if it doesn't have a program id then don't save it
							if (!_.isNumber(protocol.fertilityProgramTypeId)) {
								// 3rd protocols that have been set back to --select-- should be removed from the db
								if (!protocol.fertilityProgramTypeId && protocol.protocolTypeId === 3) {
									var protocolToBeDeleted = _.find(originalProtocols, {herdFertilityProtocolId: protocol.herdFertilityProtocolId});

									if (protocolToBeDeleted) {
										parallelFunctions.push(function deleteRemovedFertilityProtocolInParallel(done) {
											api.deleteHerdFertilityProtocol(protocol.herdFertilityProtocolId, function herdFertilityProtocolUpdated(err) {
												if (err) {
													log.error('Error deleting protocol ' + err);
												}

												log.info('protocol ' + protocol.herdFertilityProtocolId + ' (protocolTypeId: ' + protocol.protocolTypeId + ') deleted!');
												done(null);
											});
										});
									}
								}

								// skip the remainder of the steps for this item
								return;
							}

							var thisOriginalProtocol = _.find(originalProtocols, {protocolTypeId: protocol.protocolTypeId});

							if (thisOriginalProtocol) {
								protocol.herdFertilityProtocolId = thisOriginalProtocol.herdFertilityProtocolId;
							}

							//	no duration field should exist if isHDAI is false
							if (!_.find(MSF.lists.fertilityProgramType, {fertilityProgramTypeId: protocol.fertilityProgramTypeId}).isHDAI) {
								protocol.duration = null;
							}

							if (thisOriginalProtocol) {
								parallelFunctions.push(function updateHerdFertilityProtocolInParallel(done) {
									api.updateHerdFertilityProtocol(_.extend(thisOriginalProtocol, protocol), function herdFertilityProtocolUpdated(err) {
										if (err) {
											log.error('Error updating protocol ' + err);
										}

										log.info('protocol ' + protocol.herdFertilityProtocolId +
											' (protocolTypeId: ' + protocol.protocolTypeId + ') updated!');

										done(null);
									});
								});
							} else {
								var baseHerdFertilityProtocol = {
									herdFertilityPlanId: (originalActiveHerdFertilityPlan || activeHerdFertilityPlan).herdFertilityPlanId,
									protocolTypeId: null,
									fertilityProgramTypeId: null,
									duration: null,
									startWeekdayId: null,
									createdBy: null,
									startWeek: null
								};

								parallelFunctions.push(function createHerdFertilityProtocolInParallel(done) {
									api.createHerdFertilityProtocol(_.extend(baseHerdFertilityProtocol, protocol), function herdFertilityProtocolCreated(err, responseData) {
										if (err) {
											log.error('Error updating protocols ' + err);
										}

										log.info('herdFertilityProtocol created with herdFertilityProtocolId: ' + responseData.herdFertilityProtocolId);
										done(null);
									});
								});
							}
						});

						if (ffExports.pgCleanUpShot.show(parityTypeId)) {
							parallelFunctions.push(function updateHerdFertilityPlan(done) {
								var herdFertilityPlan = activeHerdFertilityPlan;
								herdFertilityPlan.timeToPGCleanShot = ffExports.pgCleanUpShot.inputs.timeToPGCleanShot;
								herdFertilityPlan.timeUnitTypeId = ffExports.pgCleanUpShot.inputs.timeUnitTypeId;

								api.updateHerdFertilityPlan(herdFertilityPlan, function herdFertilityPlanUpdated(err, result) {
									if (err) {
										log.error('Error updating herd fertility plan: ' + err);
									}

									log.info('Herd fertility plan updated.');
									done(null);
								});
							});
						}

						async.parallel(parallelFunctions, function allDone(err) {
							if (err) {
								return log.error('Error creating protocols ' + err);
							}

							log.info('all done creating/updating protocols');
							ffExports.load.planAndProtocols(parityTypeId, function makeFormPristine() {
								form.$setPristine();
							}); //update originalProtocols

							MSF.notify.success('Protocols saved successfully!');
						});
					}
				},

				resetAll: function resetAllVariables() {
					originalProtocols = [];
					activeHerdFertilityPlan = null;
					originalActiveHerdFertilityPlan = null;
				},

				errors: null,

				doneLoading: false,

				pgCleanUpShot: {
					inputs: {
						timeToPGCleanShot: 7,
						timeUnitTypeId: _.get(_.find(MSF.lists.unitType,{code:"DAY"}),'unitTypeId')
					},

					show: function show(parityTypeId) {
						var activeHerdFertilityProgram = MSF.getActiveHerdFertilityProgram();

						switch (parityTypeId) {
							case 2: // parity 2 is 1st lactation 1
								return activeHerdFertilityProgram.l1CleanUpShot;
							case 3: // parity 3 is lactation 2+
								return activeHerdFertilityProgram.l2CleanUpShot;
							default:
								return false;
						}
					}
				},

				timeUnitType: [
					{value:_.get(_.find(MSF.lists.unitType,{code:"DAY"}),'unitTypeId'),text:_.get(_.find(MSF.lists.unitType,{code:"DAY"}),'name')},
					{value:_.get(_.find(MSF.lists.unitType,{code:"WEEK"}),'unitTypeId'),text:_.get(_.find(MSF.lists.unitType,{code:"WEEK"}),'name')}
				]
			};

			return ffExports;
		}
	]);
})();
